import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/react';

const ImageCarousel = dynamic(() => import('./ImageCarousel').then((m) => ({ default: m.ImageCarousel })));

const ImageCarouselConfig = {
  name: 'ImageCarousel',
  displayName: 'Image Carousel',
  helperText: 'A carousel component that displays images with optional titles, subtitles, and links.',
  inputs: [
    {
      name: 'theme',
      type: 'enum',
      enum: [
        { label: 'Light', value: 'light' },
        { label: 'Dark', value: 'dark' },
      ],
      defaultValue: 'light',
      required: true,
    },
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'round',
      type: 'boolean',
      defaultValue: false,
      required: true,
      displayName: 'Rounded Corners',
      helperText: 'Whether to apply rounded corners to the images.',
    },
    {
      name: 'items',
      type: 'list',
      required: true,
      subFields: [
        {
          name: 'image',
          type: 'file',
          required: true,
        },
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'subtitle',
          type: 'richText',
        },
        {
          name: 'url',
          displayName: 'Link',
          helperText: 'URL to navigate to when the image is clicked',
          type: 'url',
        },
        {
          name: 'openInNewWindow',
          type: 'boolean',
          displayName: 'Open in new tab',
          helperText: 'Whether to open the link in a new tab',
          defaultValue: false,
        },
      ],
    },
  ],
};

Builder.registerComponent(ImageCarousel, ImageCarouselConfig);
